import { render, staticRenderFns } from "./WaysOfLearning.vue?vue&type=template&id=2c90b9c6&scoped=true&"
import script from "./WaysOfLearning.vue?vue&type=script&lang=js&"
export * from "./WaysOfLearning.vue?vue&type=script&lang=js&"
import style0 from "./WaysOfLearning.vue?vue&type=style&index=0&id=2c90b9c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c90b9c6",
  null
  
)

export default component.exports